var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.schedules),function(schedule){return _c('Schedule',_vm._b({key:schedule.key,attrs:{"max-settings":_vm.maxSettings,"current-settings":_vm.currentSettings}},'Schedule',schedule,false,true))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }